<template>
  <div style="padding: 64px 148px">
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: center;
        widows: 0;
        orphans: 0;
        font-size: 22pt;
      "
    >
      <span style="font-family: '等线'; font-weight: bold">腾讯智慧医药管理平台</span>
      <span style="font-family: '等线'; font-weight: bold">（TSEP）</span>
      <span style="font-family: '等线'; font-weight: bold">文档</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: center;
        widows: 0;
        orphans: 0;
        font-size: 22pt;
      "
    >
      <span style="font-family: '等线'; font-weight: bold">&#xa0;</span>
    </p>
    <p style="margin-top: 0pt; margin-bottom: 0pt; widows: 0; orphans: 0; font-size: 22pt">
      <span style="font-family: '等线'; font-weight: bold" class="line_height_50">常见问题</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">1、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">腾讯智慧医药</span>
      <span style="font-family: '等线'; font-weight: bold">管理</span>
      <span style="font-family: '等线'; font-weight: bold">平台具备哪些功能？</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">平台</span>
      <span style="font-family: '等线'">搭配了PC管理端和小程序移动端。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">PC管理端为医药行业数字化管理者</span>
      <span style="font-family: '等线'">提供了内容</span>
      <span style="font-family: '等线'">管理</span>
      <span style="font-family: '等线'">、数据追踪、用户</span>
      <span style="font-family: '等线'">管理、企业自定义配置等多种功能。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        小程序移动端为医药行业医药代表和HCP提供内容阅读、会议参与等多种功能。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        整体上，为医药行业企业提供了针对学术推广的数字化解决方案，为企业实现学术内容的快捷传播、效果评价和数据分析能力。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">2、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">如何申请使用腾讯智慧医药管理平台？</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        企业相关负责人直接使用手机号注册，并上传企业相关信息和证照后即完成申请。平台运营人员将主动联系您，并协助您完成相关账号的开通。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">3、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">试用期是多久？试用版有什么功能？</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">在运营人员确认您的企业注册成功后，</span>
      <span style="font-family: '等线'">可</span>
      <span style="font-family: '等线'">为您开通试用账号</span>
      <span style="font-family: '等线'">。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">试用账号具备完备的全部功能，试用期为6</span>
      <span style="font-family: '等线'">0</span>
      <span style="font-family: '等线'">
        天。您须在试用期期间确认是否购买相应服务，我司工作人员将及时与您对接。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">4、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">企业的微信</span>
      <span style="font-family: '等线'; font-weight: bold">公众号如何绑定</span>
      <span style="font-family: '等线'; font-weight: bold">平台</span>
      <span style="font-family: '等线'; font-weight: bold">？</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">账号开通后，我司工作人员将辅助您完成公众号绑定事宜。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">您需要准备相关公众号的A</span>
      <span style="font-family: '等线'">pp</span>
      <span style="font-family: '等线'">ID、Ap</span>
      <span style="font-family: '等线'">p</span>
      <span style="font-family: '等线'">Secret</span>
      <span style="font-family: '等线'">，并在我司工作人员协助下，在相关公众号</span>
      <span style="font-family: '等线'">配置IP白名单、配置网页授权域名</span>
      <span style="font-family: '等线'">。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'">5、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">内容管理模块都有什么功能？</span>
      <br />
      <span style="font-family: '等线'" class="line_height_20">
        平台的内容管理模块，具备同时管理公众号、小程序内容的能力。您可以对您绑定的多个公众号的内容进行集中有效的快速新建、修改、发布等多种操作。并支持多公众号、多类目标人群的内容定向发布，且支持自定义标签，实现内容与公司的业务强绑定，并快速查询和追踪。
      </span>
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">6、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">数据中心集成了哪些数据？</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        平台对公众号、小程序的用户阅读行为的数据实现了集成，尤其在小程序用户签署授权协议的情况下，可返回个人阅读行为数据。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        平台对目标HCP参与学术会议的行为数据实现了定时反馈，在使用企业配合对接数据的情况下，可实现对会议召开的数量、规范情况、参会人员信息、参会人员的参与时长等数据进行集中反馈。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">7、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">用户管理功能提供哪些服务？</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        在使用企业对接API之后，平台可实现对公众号、小程序的使用用户（包括HCP和代
      </span>
      <span style="font-family: '等线'">
        表）数据进行统一集成。平台管理者可查询目标HCP和代表的在学术过程中沉淀的各类个人行为数据，并直观的看到用户画像（该模块在逐渐迭代研发中）。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        未来，在使用企业主动要求的情况下，平台也将支持和企业的用户数据库打通，实现对目标HCP和代表的数据增删改能力。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-indent: -18pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">8、</span>
      <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">平台支持哪些企业个性化配置？</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-left: 18pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">对于移动端，平台支持小程序的l</span>
      <span style="font-family: '等线'">ogo</span>
      <span style="font-family: '等线'">
        、名称、企业名称、法律声明、用户授权书的自定义配置。未来版本还将计划对小程序的页面布局提供灵活配置能力。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 22pt;
      "
      class="line_height_50"
    >
      <span style="font-family: '等线'; font-weight: bold">使用入门</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">（1）登录&amp;注册</span>
    </p>
    <p class="login">
      <img alt="" :src="g_imgSrc.loginPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        1.1
        首次进入网站，如果没有事先由己方公司管理员加入权限，则会进入注册流程。视为新企业申请注册账号。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        1.2 非注册用户，亦采取手机号方式登录，您可以勾选自动登录，一个月之内免去登录流程
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">（2）试用账号</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">首次注册后，经过核准后，可直接启动试用账号。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">试用账号功能包括：</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        基础版（已对外开放，具备公众号内容管理能力、数据中心、分人群分发等能力）
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        小程序版（预计2020年11月开放，提供移动端医生拜访能力）
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        腾讯会议版（预计2020年12月开放，提供移动端医生会议参会能力，管理端会议数据集成）
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        企业微信托管版（预计2021年2月开放，提供IDaaS账号统一能力，集成企业微信应用管理、通讯录管理、消息管理，会话监控能力）
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">（3）正式账号</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        在试用账号使用60天内，请确认与平台签订商务合同。平台将为您开设正式账号。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">正式账号可以选用其中几个功能或全部功能。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">（4）设置</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        登录成功后，点击左侧最下方“设置”进入设置页面，可以针对需要进行相关配置。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">4.1</span>
      <span style="font-family: '等线'; font-weight: bold">&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">公众号设置</span>
    </p>
    <p class="setup">
      <img alt="" :src="g_imgSrc.setPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        公众号设置是唯一需要平台工作人员配合的，公众号设置生效前需要发送邮件给平台，平台将安排工作人员指导企业设置。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        您需添加公众号的AppID、AppSecret、IP白名单、网页授权域名。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">在公众号设置里，您可以对公众号进行新增和禁用。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">4.2</span>
      <span style="font-family: '等线'; font-weight: bold">&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">管理员设置</span>
    </p>
    <p class="setup">
      <img alt="" :src="g_imgSrc.adminSetPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">在管理员设置页面，您可以新增最多3个管理员。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">管理员和操作员的权限区别为——</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        内容管理：管理员可以操作所有的公众号，操作员只能操作自己所分配的公众号
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        数据中心：管理员可以看到及筛查所有数据（包括未来的会议数据、企业微信数据），操作员只能筛查自己公众号相关的数据
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">用户管理：管理员可见，操作员不可见</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">设置：管理员可见，操作员不可见</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">4.3</span>
      <span style="font-family: '等线'; font-weight: bold">&#xa0;</span>
      <span style="font-family: '等线'; font-weight: bold">策略设置</span>
    </p>
    <p class="setup">
      <img alt="" :src="g_imgSrc.strategyPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">在策略设置页面，可以设置公众号群发内容的范围</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        您可以用领域、科室来圈定用户的基础范围。可以用职称、等级、性别、所在地来基础范围内，再筛出想要的具体条件的医生。并可以用备注和策略名称来区分不同的策略。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">注意：新建的策略一般需要15分钟以后才能生效。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">4.4 标签设置</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">（待添加功能）</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">4.5 企业设置</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">（待添加功能）</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">（5）内容管理</span>
    </p>
    <p class="setup">
      <img alt="" :src="g_imgSrc.publishPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'; font-weight: bold">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        内容管理页面可以对发布到公众号、小程序的内容进行新增、下架、编辑、查询。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">5.1 内容的增删改</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        点击“新建内容”，新增图文消息。新增时可以添加多个维度的内容相关的标签。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">点击“编辑”可以对内容进行修改</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">点击“数据”可以看到单篇内容的核心数据</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">点击“下架”可以将内容从小程序下架</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">5.2 内容查找</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        可以根据所发布公众号、发布状态、发布策略、所属产品标签、最后操作时间、标题关
      </span>
      <span style="font-family: '等线'">键词进行搜索</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">5.3 内容发布</span>
    </p>
    <p>
      <img alt="" :src="g_imgSrc.publicPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        勾选文章（一次最多8篇）后，可以点击“发布公众号”，发布到公众号，并在发布操作流程中，调整文章的顺序、发布的策略、发布的公众号。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        勾选文章（一次最多8篇）后，可以点击“发布小程序”，发布到小程序。
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">（6）数据中心</span>
    </p>
    <p class="setup">
      <img alt="" :src="g_imgSrc.dataCenterPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'; font-weight: bold">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">6.1 整体数据</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        按照时间维度，对单日当天所有数据进行汇总，并可以按照公众号维度和时间窗口进行查询
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">6.2 单篇数据</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        按照单篇稿件的维度，对每一篇文章所涉及的数据进行汇总，可以按照公众号、时间窗口和标题关键词进行查询
      </span>
      <br />
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">（7）用户管理</span>
    </p>
    <p class="setup">
      <img alt="" :src="g_imgSrc.userPage" class="img" />
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        分为医生和代表两个角色进行管理，数据来自企业对接的数据，并在未来（预计2020年12月）梳理成用户画像
      </span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">7.1 医生管理</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">
        可以按照医生姓名、手机号查询，屏蔽了敏感信息。未来（2020年11月）对代表在移动端开放其目标医生的个人数据查询。点击详情可查询详细数据（未来
      </span>
      <span style="font-family: '等线'">将增加</span>
      <span style="font-family: '等线'">用户画像）</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_30"
    >
      <span style="font-family: '等线'; font-weight: bold">7.2 代表管理</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-indent: 21pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
      class="line_height_20"
    >
      <span style="font-family: '等线'">可以按照代表姓名、手机号查询，屏蔽了敏感信息。</span>
    </p>
    <p
      style="
        margin-top: 0pt;
        margin-bottom: 0pt;
        text-align: justify;
        widows: 0;
        orphans: 0;
        font-size: 10.5pt;
      "
    >
      <span style="font-family: '等线'">&#xa0;</span>
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
.login {
  width: 550px;
  height: 193px;
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.setup {
  width: 100%;
  height: 100%;
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.line_height_50 {
  line-height: 50px;
}
.line_height_30 {
  line-height: 30px;
}
.line_height_20 {
  line-height: 20px;
}
</style>
